/** Severity names. */
export default {
  notice: { name: 'Notice' },
  warning: { name: 'Warning' },
  critical: { name: 'Critical' },
};
